module.exports = __webpack_public_path__ + "img/anli-1.241364f1.png";